import { defineMessages, type IntlShape } from 'react-intl'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { infoIcon } from './snackbarUtils'

const messages = defineMessages({
  removedOffers: {
    id: 'ixcPEm9pYNXVcb7sf5zf',
    defaultMessage: 'LuxPlus+ member-only offers were removed from your cart because your membership has ended.',
  },
  rejoin: {
    id: 'Sdz-Jc3YHzLLV1VM-FqN',
    defaultMessage: 'Rejoin LuxPlus+',
  },
})

const NOTIFIED_STORAGE_KEY_PREFIX = 'luxplus.membershipCartCleanup.notified'

function notifiedStorageKey(memberId: string, eventId: string): string {
  return `${NOTIFIED_STORAGE_KEY_PREFIX}:${memberId}:${eventId}`
}

export function hasShownLuxPlusMembershipCartCleanupNotice(memberId: string, eventId: string): boolean {
  return !!getLocalStorage(notifiedStorageKey(memberId, eventId))
}

/**
 * Shows one notice per membership-end event in this browser.
 * Call only after a soft-delete has succeeded. A later successful batch for the same event does not repeat it.
 */
export function showLuxPlusMembershipCartCleanupNotice(intl: IntlShape, memberId: string | undefined, eventId: string) {
  if (!memberId || !eventId) return
  const key = notifiedStorageKey(memberId, eventId)
  if (getLocalStorage(key)) return
  setLocalStorage(key, true)
  showSnackbar(intl.formatMessage(messages.removedOffers), 'neutral', {
    icon: infoIcon,
    action: {
      label: intl.formatMessage(messages.rejoin),
      to: `/${LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE}`,
    },
  })
}
